/* eslint-disable react-hooks/exhaustive-deps */
import { Slider as MSlider } from "@blueprintjs/core"
import { MouseEvent, useEffect } from "react"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"


/* Protopia Ecosystem component */
export interface IZoomProps {
   
}
const Zoom = (props: IZoomProps): JSX.Element => {
    const zoom: number = useLandingStore((state: ILandingStore) => state.zoom)
    const currentZoom   = useSyncState<number>(zoom)
    useEffect(() => {
        currentZoom.set(zoom)
    }, [zoom])
    const onCurrentZoom = (value: number) => {
        currentZoom.set(value)
    }
    const onZoom = (value: number) => { 
        useLandingStore.setState({zoom: value})
    }
    const onMouseDown = (evt: MouseEvent) => {
        evt.stopPropagation()
        evt.preventDefault()
    }
    const onMouseUp = (evt: MouseEvent) => {
        // evt.stopPropagation()
        // evt.preventDefault()
    }
    return <div className='pe-zoom-container px-3' onDragStart={onMouseDown} onDragEnd={onMouseUp} onMouseDown={onMouseDown} onMouseUp={onMouseUp}>
        <MSlider
            min={ 25 }
            max={ 200 }
            stepSize={ 5 }
            labelStepSize={ 25 }
            value={ currentZoom.get() }
            onChange={ onCurrentZoom } 
            onRelease={ onZoom }
        /> 
    </div>
}
export default Zoom